import React from "react";
import { Tab } from "react-bootstrap";

import useFilter from "../../../hooks/useFilter";

import UserTabsComponent from "../../../components/private/tabs";
import UserCommentContainer from "../comment";
import UserMessageContainer from "../message/userMessageContainer";

function UserMessagesContainer() {
  const { onChange, filterState } = useFilter();
  return (
    <UserTabsComponent
      defaultActiveKey={filterState["tab"]}
      onSelect={(k) => {
        onChange("tab", k);
      }}
    >
      <Tab eventKey="my_message" title="پیام‌های من">
        {(filterState["tab"] === "my_message" || !filterState["tab"]) && (
          <UserMessageContainer />
        )}
      </Tab>
      <Tab eventKey="my_comments" title="نظرات من">
        {filterState["tab"] === "my_comments" && <UserCommentContainer />}
      </Tab>
    </UserTabsComponent>
  );
}

export default UserMessagesContainer;
